import React from 'react';
import PropTypes from 'prop-types';
import { useRepeaterCardIntersection } from '../../helpers/repeaters/use-repeater-card-intersection';
import Card from '../card';
import { DEFAULT_REPEATER_FOR_SAVING } from '../card/constants';
import CarouselRepeaterBlock from './carousel-layout';
import EmptyState from './empty-state';
import GridRepeaterBlock from './grid-layout';

const RepeaterBlock = React.memo(props => {
  const {
    repeaterData: { layout, styling = 'option1', title, subTitle, linkText, link, items, emptyStateText },
    repeaterKey,
    sliderSettings,
    isFullWidthCarousel,
    isDisplayItemSubTitle,
    isDisplayItemExcerpt,
    isDisplayCardSaveButton: isConfigDisplayCardSaveButton,
    pageType,
    pageActivityName,
    articleSlug
  } = props;

  const isDisplayBottomLink = !!link && !!linkText && !!items.length;
  const isDisplayCardSaveButton = repeaterKey === DEFAULT_REPEATER_FOR_SAVING || isConfigDisplayCardSaveButton;

  const { onCardInView } = useRepeaterCardIntersection({
    pageType,
    repeaterBlockName: repeaterKey,
    pageActivityName,
    articleSlug
  });

  switch (layout) {
    case 'carousel':
      return (
        <CarouselRepeaterBlock
          repeaterKey={repeaterKey}
          styling={styling}
          title={title}
          subTitle={subTitle}
          emptyStateText={emptyStateText}
          items={items}
          isFullWidthCarousel={isFullWidthCarousel}
          isDisplayBottomLink={isDisplayBottomLink}
          isDisplayItemSubTitle={isDisplayItemSubTitle}
          isDisplayItemExcerpt={isDisplayItemExcerpt}
          isDisplayCardSaveButton={isDisplayCardSaveButton}
          linkText={linkText}
          linkURL={link}
          onCardInView={onCardInView}
          sliderSettings={sliderSettings}
        />
      );
    case 'grid':
      return (
        <GridRepeaterBlock
          repeaterKey={repeaterKey}
          styling={styling}
          title={title}
          subTitle={subTitle}
          emptyStateText={emptyStateText}
          items={items}
          isDisplayBottomLink={isDisplayBottomLink}
          isDisplayItemSubTitle={isDisplayItemSubTitle}
          isDisplayItemExcerpt={isDisplayItemExcerpt}
          isDisplayCardSaveButton={isDisplayCardSaveButton}
          linkText={linkText}
          linkURL={link}
          onCardInView={onCardInView}
        />
      );
    default:
      return null;
  }
});

RepeaterBlock.propTypes = {
  repeaterData: PropTypes.shape({
    layout: PropTypes.oneOf(['grid', 'carousel']),
    styling: PropTypes.oneOf(['option1', 'option2', 'option3', 'option4', 'option5']),
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    linkText: PropTypes.string,
    link: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
    emptyStateText: EmptyState.propTypes.emptyStateText
  }),
  repeaterKey: PropTypes.string.isRequired,
  sliderSettings: PropTypes.object,
  isFullWidthCarousel: PropTypes.bool,
  isDisplayItemSubTitle: PropTypes.bool,
  isDisplayItemExcerpt: PropTypes.bool,
  isDisplayCardSaveButton: PropTypes.bool,
  pageType: PropTypes.oneOf(['dashboard', 'ContentFeed', 'Article', 'StartPage', 'ResultPage', 'coins']).isRequired,
  pageActivityName: PropTypes.string,
  articleSlug: PropTypes.string
};

RepeaterBlock.displayName = 'RepeaterBlock';

export { RepeaterBlock };
